import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { themes, optionalAvathar } from "services/constants";
import { useSelector } from "react-redux";
import { tableRowSx } from "services/constants";
import { useForm } from "react-hook-form";
import { individualAssignHeader } from "pages/HR/Headers";
import { formKeyText } from "services/constants/Styles";
import { Info } from "@mui/icons-material";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { CustomAutoComplete } from "components/CustomComponents";
import { CustomTextBox } from "components/CustomComponents";
import { minimum3Characters } from "services/constants/ErrorMessages";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { CustomButton } from "components/CustomComponents";
import { customAPI } from "services/utils/CustomAPI";
import { showToast } from "services/utils/Status";
import { tooltipStyleProps } from "services/constants/Styles";
import { TableEmptyState } from "components/CustomComponents/EmptyState";

const keys = [
  "status",
  "user_name",
  "repayment_date",
  "next_repayment_date",
  "amount",
  "advance_type",
  "description",
  "reason",
];

export const LeaveCredit = ({
  selectedArray,
  setShowCreditDetils,
  setSelectedArray,
  selectedDetails,
  setSelectedDetails,
  setFetchUserDetails,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const { domain, globalSearchValue } = useSelector(
    (state) => state.tokenReducer
  );

  const avilableUser = selectedArray
    .filter((item) => item.effective_to === null)
    .map((item) => item);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [advanceSalaryData, setAdvanceSalaryData] = useState(avilableUser);
  const [reasonForLeaveCredit, setDescriptions] = useState("");
  const containerRef = useRef(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  // const userIds = selectedArray.map((item) => item.user_id);

  const userIds = selectedArray
    .filter((item) => item.effective_to === null)
    .map((item) => item.user_id);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const updateReason = (event) => {
    if (event.target.value.length <= 1024) {
      setValue("description", event.target.value);
      setDescriptions(event.target.value);
    }
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [page]);

  const onSubmit = async (data) => {
    if (data) {
      const response = await customAPI(`${domain}manual-leave-credit/`, "PUT", {
        ...data,
        user_id: userIds,
      });
      if (response.ok) {
        showToast("success", response?.responseDetails?.message);
        setShowCreditDetils(false);
        setFetchUserDetails(true);
        setSelectedDetails([]);
        setSelectedArray([]);
        reset();
      }
    }
  };

  const handleLeaveType = (event, data) => {
    if (data) {
      setValue("leave_type", data?.label);
      setValue("leave_type_id", data?.leave_type_id);
    } else {
      setValue("leave_type", "");
      setValue("leave_type_id", null);
    }
  };

  const handleCount = (event) => {
    const value = event.target.value;
    if (value === "" || value === "-" || value === ".") {
      setValue("additional_creditordebit", value);
      return;
    }
    const regex = /^(?:-?(?:0|[1-9]\d{0,2})(?:\.\d{0,2})?)?$/;
    if (regex.test(value)) {
      setValue("additional_creditordebit", value);
    }
  };

  useEffect(() => {
    const filteredResults = avilableUser?.filter((item) =>
      keys.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setAdvanceSalaryData(filteredResults);
    setPage(0);
  }, [globalSearchValue, avilableUser]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ padding: 10 }}>
      <React.Fragment>
        <Mui.Grid container sx={{ paddingLeft: 2, paddingRight: 2 }}>
          <Mui.Grid container>
            <BackArrow
              actionFunction={() => {
                setShowCreditDetils(false);
                // setSelectedDetails([]);
                // setSelectedArray([]);
              }}
            />
            <Mui.Typography
              sx={{ fontWeight: "bold", fontSize: 27, paddingTop: 1 }}
            >
              Leave Management System / Credit Leave
            </Mui.Typography>
          </Mui.Grid>
          <Mui.TableContainer
            ref={containerRef}
            component={Mui.Paper}
            sx={{ mt: 2, width: "100%", maxHeight: 440 }}
          >
            <Mui.Table className="border">
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                  position: "sticky",
                  top: -1,
                  zIndex: 10,
                  "& .MuiTableCell-root": {
                    height: "10px",
                    padding: "6px 12px",
                  },
                }}
              >
                <Mui.TableRow sx={tableRowSx}>
                  {individualAssignHeader?.map((value) => (
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                      }}
                    >
                      {value?.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {advanceSalaryData?.length === 0 ? (
                  <TableEmptyState dataLength={avilableUser} />
                ) : (
                  advanceSalaryData
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((value) => (
                      <Mui.TableRow sx={tableRowSx}>
                        {individualAssignHeader.map((head) => (
                          <Mui.TableCell>
                            {head.key === "user_name" ? (
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={value?.user_name
                                    ?.charAt(0)
                                    .toUpperCase()}
                                  src={value?.image_url ?? optionalAvathar}
                                />{" "}
                                &nbsp;
                                {value?.user_name}
                              </Mui.Stack>
                            ) : value[head.key] ? (
                              value[head.key]
                            ) : (
                              "N/A"
                            )}
                          </Mui.TableCell>
                        ))}
                      </Mui.TableRow>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
          <Mui.Grid
            container
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            {advanceSalaryData?.length > 25 && (
              <Mui.TablePagination
                className="custom-pagination"
                rowsPerPageOptions={[25, 50, 75, 100]}
                component="div"
                count={advanceSalaryData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Mui.Grid>

          <Mui.Grid
            container
            sx={{
              border: `2px solid ${themes.sidebarDivider}`,
              borderRadius: "10px 10px 10px 10px",
              mt: 3,
              padding: 2,
              ml: 15,
              mr: 15,
            }}
          >
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid item xs={5.5}>
                {" "}
                <Mui.Typography sx={formKeyText}>
                  Leave Type &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Select the leave type for which additional leave will be credited or debited, such as Annual Leave, Sick Leave, or Casual Leave."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={5}>
                <CustomAutoComplete
                  dataList={selectedDetails?.map((obj) => ({
                    ...obj,
                    label: obj?.leave_type_name,
                  }))}
                  selectedValue={watch("leave_type")}
                  rules={{
                    ...register("leave_type", {
                      required: "Leave type name is required",
                    }),
                  }}
                  updateDataFunction={handleLeaveType}
                  placeHolder="Select the leave type name"
                  errorMessage={
                    errors?.leave_type?.message
                      ? errors?.leave_type?.message
                      : ""
                  }
                  textBoxError={errors.leave_type ? true : false}
                />
              </Mui.Grid>
            </Mui.Grid>
            {selectedArray?.length === 0 && (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid item xs={5.5}>
                  {" "}
                  <Mui.Typography sx={formKeyText}>
                    Already Credited Leave &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Indicates the number of leave days that have already been credited to the employee for the selected leave type."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>

                <Mui.Grid item xs={5}>
                  <Mui.Typography sx={{ fontWeight: "bold", paddingTop: 2 }}>
                    {selectedDetails?.credited_leave
                      ? selectedDetails?.credited_leave
                      : "0"}
                  </Mui.Typography>
                </Mui.Grid>
              </Mui.Grid>
            )}
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid item xs={5.5}>
                {" "}
                <Mui.Typography sx={formKeyText}>
                  Additional leave to be Credit/Debit &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Enter the number of leave days to be added (credit) or removed (debit) from the employee’s leave balance."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={5}>
                <CustomTextBox
                  selectedValue={watch("additional_creditordebit")}
                  rules={{
                    ...register("additional_creditordebit", {
                      required: "Leave credit/debit is required",
                      validate: {
                        validatingZeroValue: (value) => {
                          if (value === "0") {
                            return "Value must be less or greater than zero";
                          } else {
                            return true;
                          }
                        },
                      },
                    }),
                  }}
                  updateDataFunction={handleCount}
                  placeHolder="Enter leave count for credit/debit"
                  errorMessage={
                    errors?.additional_creditordebit?.message
                      ? errors?.additional_creditordebit?.message
                      : ""
                  }
                  textBoxError={errors.additional_creditordebit ? true : false}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid item xs={5.5}>
                {" "}
                <Mui.Typography sx={formKeyText}>
                  Reason for Credit or Debit &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Provide a reason for adjusting the leave balance, such as policy updates, corrections, or special approvals."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={5}>
                <Mui.Typography sx={{ fontWeight: "bold", paddingTop: 2 }}>
                  <CustomTextBox
                    type="multiline"
                    selectedValue={reasonForLeaveCredit}
                    rules={{
                      ...register("description", {
                        required: "Reason is required",
                        validate: {
                          minLengthNoSpaces: (value) => {
                            if (value?.trim().length < 3 && value !== "") {
                              return minimum3Characters;
                            } else if (
                              value?.trim().length > 255 &&
                              value !== ""
                            ) {
                              return "Maximum length is 255 characters";
                            } else {
                              return true;
                            }
                          },
                          atleastOneCharacterWithSpaceReg: (value) => {
                            if (
                              atleastOneCharacterWithSpace.test(value) ||
                              value === ""
                            ) {
                              return true;
                            } else {
                              return "Atleast one alphabet required";
                            }
                          },
                        },
                      }),
                    }}
                    updateDataFunction={updateReason}
                    placeHolder="Enter reason for leave credit/debit"
                    errorMessage={
                      errors?.description?.message
                        ? errors?.description?.message
                        : ""
                    }
                    textBoxError={errors.description ? true : false}
                  />
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid
              xs={10.5}
              container
              sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}
            >
              <CustomButton
                actionName="Submit"
                typeName="submit"
                //   actionFuntion={() => {
                //     setShowCreditDetils(false);
                //   }}
              />
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </React.Fragment>
    </form>
  );
};
